import { Box, Container, Stack, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

interface LegalPageProps {
  titleKey: string;
  bodyKey: string;
}

/**
 * Gemeinsame Hülle für /impressum, /datenschutz, /agb, /lizenz.
 *
 * Texte kommen aus i18n-Namespace ``legal`` (Markdown erlaubt). Die Seiten
 * sind unauthentifiziert erreichbar — Pflichtinformationen müssen ohne
 * Login sichtbar sein.
 */
export function LegalPage({ titleKey, bodyKey }: LegalPageProps) {
  const { t } = useTranslation('legal');
  return (
    <Container size={800} py="xl">
      <Stack gap="md">
        <Title order={1} c="#072c5e">
          {t(titleKey)}
        </Title>
        <Box className="lft-markdown" style={{ lineHeight: 1.6, color: '#333' }}>
          <ReactMarkdown>{t(bodyKey)}</ReactMarkdown>
        </Box>
      </Stack>
    </Container>
  );
}

export function ImpressumPage() {
  return <LegalPage titleKey="impressum.title" bodyKey="impressum.body" />;
}
export function DatenschutzPage() {
  return <LegalPage titleKey="datenschutz.title" bodyKey="datenschutz.body" />;
}
export function AGBPage() {
  return <LegalPage titleKey="agb.title" bodyKey="agb.body" />;
}
export function LizenzPage() {
  return <LegalPage titleKey="lizenz.title" bodyKey="lizenz.body" />;
}
